import classNames from 'clsx';
import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import { TXTWCL_PlayingX, TXTWCL_RegisteredX__number } from './RegisteredPlayers.messages.json';
import styles from './RegisteredPlayers.scss';

export interface Props {
  numOfPlayers: number;
  isLiveRace?: boolean;
}

const RegisteredPlayers: React.FC<Props> = ({ numOfPlayers, isLiveRace }) => (
  <div className={classNames(styles.playStatus)}>
    <div className={classNames(styles.oval, isLiveRace ? styles.playing : styles.registered)} />
    {isLiveRace ? (
      <Translation {...TXTWCL_PlayingX} />
    ) : (
      <Translation {...TXTWCL_RegisteredX__number} />
    )}
    <span className={styles.players}>{numOfPlayers}</span>
  </div>
);

export default RegisteredPlayers;
